
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/disposal",
      function () {
        return require("private-next-pages/disposal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/disposal"])
      });
    }
  